import React, { Component } from "react";
import { StyleSheet, css } from "aphrodite";
import { connect } from "react-redux";

import { getUserPosition } from "../../redux/actions/getUserPosition";
import GoogleMapReact from "google-map-react";

function createMapOptions(maps) {
  return {
    // panControl: false,
    // mapTypeControl: false,
    // scrollwheel: false,
    styles: [
      {
        elementType: "geometry",
        stylers: [
          {
            color: "#212121"
          }
        ]
      },
      {
        elementType: "labels.icon",
        stylers: [
          {
            visibility: "off"
          }
        ]
      },
      {
        elementType: "labels.text.fill",
        stylers: [
          {
            color: "#757575"
          }
        ]
      },
      {
        elementType: "labels.text.stroke",
        stylers: [
          {
            color: "#212121"
          }
        ]
      },
      {
        featureType: "administrative",
        elementType: "geometry",
        stylers: [
          {
            color: "#757575"
          }
        ]
      },
      {
        featureType: "administrative.country",
        elementType: "labels.text.fill",
        stylers: [
          {
            color: "#9e9e9e"
          }
        ]
      },
      {
        featureType: "administrative.land_parcel",
        stylers: [
          {
            visibility: "off"
          }
        ]
      },
      {
        featureType: "administrative.locality",
        elementType: "labels.text.fill",
        stylers: [
          {
            color: "#bdbdbd"
          }
        ]
      },
      {
        featureType: "poi",
        elementType: "labels.text.fill",
        stylers: [
          {
            color: "#757575"
          }
        ]
      },
      {
        featureType: "poi.park",
        elementType: "geometry",
        stylers: [
          {
            color: "#181818"
          }
        ]
      },
      {
        featureType: "poi.park",
        elementType: "labels.text.fill",
        stylers: [
          {
            color: "#616161"
          }
        ]
      },
      {
        featureType: "poi.park",
        elementType: "labels.text.stroke",
        stylers: [
          {
            color: "#1b1b1b"
          }
        ]
      },
      {
        featureType: "road",
        elementType: "geometry.fill",
        stylers: [
          {
            color: "#2c2c2c"
          }
        ]
      },
      {
        featureType: "road",
        elementType: "labels.text.fill",
        stylers: [
          {
            color: "#8a8a8a"
          }
        ]
      },
      {
        featureType: "road.arterial",
        elementType: "geometry",
        stylers: [
          {
            color: "#373737"
          }
        ]
      },
      {
        featureType: "road.highway",
        elementType: "geometry",
        stylers: [
          {
            color: "#3c3c3c"
          }
        ]
      },
      {
        featureType: "road.highway.controlled_access",
        elementType: "geometry",
        stylers: [
          {
            color: "#4e4e4e"
          }
        ]
      },
      {
        featureType: "road.local",
        elementType: "labels.text.fill",
        stylers: [
          {
            color: "#616161"
          }
        ]
      },
      {
        featureType: "transit",
        elementType: "labels.text.fill",
        stylers: [
          {
            color: "#757575"
          }
        ]
      },
      {
        featureType: "water",
        elementType: "geometry",
        stylers: [
          {
            color: "#000000"
          }
        ]
      },
      {
        featureType: "water",
        elementType: "labels.text.fill",
        stylers: [
          {
            color: "#3d3d3d"
          }
        ]
      }
    ]
  };
}

const AnyReactComponent = ({ text, key }) => (
  <div key={key} className={css(styles.marker)}>
    {text}
  </div>
);
class map extends Component {
  componentWillMount() {
    this.props.getUserPosition();
  }
  renderMap() {
    var pontos = this.props.lista;
    console.log(pontos, this.props.loadUsers);
    return (
      <GoogleMapReact
        // bootstrapURLKeys={{ key: "AIzaSyAraRz-dbSrgbJV_4OPrWLFyZU8ChY3mrM" }}
        defaultCenter={[this.props.lat, this.props.lng]}
        defaultZoom={11}
        options={createMapOptions}
      >
        <AnyReactComponent
          key={`asdaspoint`}
          lat={this.props.lat}
          lng={this.props.lng}
          text={""}
        />
        {pontos.map(e => {
          console.log("mapa");
          return (
            <AnyReactComponent
              key={`${e.key}point`}
              lat={e.lat}
              lng={e.lng}
              text={""}
            />
          );
        })}
      </GoogleMapReact>
    );
  }
  render() {
    return (
      // Important! Always set the container height explicitly
      <div
        style={{ height: "100%", width: "100%" }}
        className={css(styles.container)}
      >
        {/* {this.props.loadUsers === "done" ? this.renderMap() : null} */}
        <h4 className={css(styles.breve)}>Em breve</h4>
      </div>
    );
  }
}
const styles = StyleSheet.create({
  marker: {
    width: "15px",
    height: "15px",
    background: "#63F85E",
    border: "solid 1.5px #fff",
    borderRadius: "50%"
  },
  container: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    background: "#faebcc",
    border: "1px solid #f0ad4e"
  },
  breve: {
    fontWeight: "bold",
    color: "#f0ad4e"
  }
});
const mapStateToProps = state => {
  return {
    lista: state.getUserPosition.lista,
    lat: state.getUserPosition.lat,
    lng: state.getUserPosition.lng,
    loadUsers: state.getUserPosition.loadUsers
  };
};

export default connect(
  mapStateToProps,
  { getUserPosition }
)(map);



// WEBPACK FOOTER //
// ./src/assets/map/index.js